import apiFetch from '../../apiFetch'

export default function (dossierId, paperwork, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/${dossierId}/paperwork`, method: 'POST', body: paperwork, token: token, lastAccessDate })
}
